import React from 'react';
import { ApplicationState } from '../../reducers';
import { useDispatch, useSelector } from 'react-redux';
import { ComponentManagementActionType } from '../../reducers/comp.actions';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { repealSubtree } from '../../api/node';
import { UiActionType } from '../../reducers/ui.reducer';

const RepealNodeDialog: React.FC = () => {

    const open = useSelector((app: ApplicationState) => app.comp.repealNodeDialogOpen);
    const dispatch = useDispatch();
    const editorNode = useSelector((app: ApplicationState) => app.comp.editorNode);
    const contextMenuSubTree = useSelector((app: ApplicationState) => app.comp.repealNodeDialogSubtree);

    const onCancel = () => {
        dispatch({ type: ComponentManagementActionType.REPEAL_NODE_DIALOG_OPEN, open: false })
    }

    const onRepealHeader = () => {
        if (!contextMenuSubTree) {
            return;
        }

        repealSubtree(contextMenuSubTree.nodeId).then(response => {
            dispatch({ type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { severity: 'success', message: 'Node repealed', open: true } });
            let repealedNodes = response.data;
            for (let i = 0; i < repealedNodes.length; i++) {
                dispatch({ type: ComponentManagementActionType.SUBTREE_CHANGED, nodeId: repealedNodes[i].nodeId, hasChanges: true });
                dispatch({ type: ComponentManagementActionType.SUBTREE_TITLE_CHANGED, nodeId: repealedNodes[i].nodeId, newCitation: repealedNodes[i].citation, newHeading: repealedNodes[i].heading, newWorkingCopyHeading: repealedNodes[i].nodeHistory?.heading, repealed: repealedNodes[i].repealed })
                if (editorNode?.nodeId === repealedNodes[i].nodeId) {
                    dispatch({ type: ComponentManagementActionType.EDITOR_NODE_UPDATED, editorNode: repealedNodes[i] });
                }
            }
        }).catch(error => {
            dispatch({ type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { severity: 'error', message: 'Could not repeal node', open: true } });
            console.error(error);
        })
        dispatch({ type: ComponentManagementActionType.REPEAL_NODE_DIALOG_OPEN, open: false })
    }

    return (
        <Dialog maxWidth='sm' fullWidth={true} open={open} onClose={() => { }}>
            <DialogTitle>
                <Typography variant='h4'>Repeal Provision</Typography>
            </DialogTitle>
            <DialogContent>
                Are you sure you want to repeal Provision ({contextMenuSubTree?.citation ?? contextMenuSubTree?.heading}) and its associated children?
            </DialogContent>
            <DialogActions>
                <Button size='small' variant='outlined' color='primary' onClick={onRepealHeader}>Yes</Button>
                <Button size='small' variant='outlined' color='secondary' onClick={onCancel}>No</Button>
            </DialogActions>
        </Dialog>
    )
}

export default RepealNodeDialog;